const listPointsBody = document.querySelector('#filmAFConsider').querySelector('div[name=lastOpenBody]');

import auth from '../tools/storage.js';
import tools from '../tools/tools.js';


const mypopup = document.getElementById("mypopupCloud");


export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  getElement(item, index) {
    let metaData = ` fCID=${item.considerID} numReq=${item.numRequest}  `;
  
   
    return `<div ${metaData} class="row cloudMiniFilmRequest  " >
                    <b ${metaData} class="popup" popupAlert="${item.name}" popupMsg="${item.time}" pin="${item.pin ? 1 : 0}">№${item.numRequest}</b>
                    <label ${metaData} >${item.name}</label>
                    <div class="${item.pin && 'pin'}"></div>
                  </div>`;
  },


  // drawAddDataInContainer(fcID, numReq, filmName, time) {
  //   let newItem;
  //   newItem.considerID = fcID ? fcID : 0;
  //   newItem.numReq = numReq ? numReq : 0;
  //   newItem.name = filmName ? filmName : 0;
  //   newItem.time = time ? time : 0;

  //   let htmlBefore = listPointsBody.innerHTML;
  //   this.cleanContainer();
  //   listPointsBody.innerHTML = this.getElement(newItem);
  //   listPointsBody.innerHTML += htmlBefore;
    

  // }
  drawDataInContainer(listWithData) {
    this.cleanContainer();
    let HTMLBODY = '';

    if (listWithData) {
      // console.log(arrcntUserReviewer);

      HTMLBODY = '';
      listWithData.forEach((item, index) => {
        // console.log
        HTMLBODY += this.getElement(item, index);
      });
      listPointsBody.innerHTML = HTMLBODY;



      const date = new Date();
      const curTimeZone = (date.getTimezoneOffset())/60 * -1;

      let allPopUpListenerClass = listPointsBody.querySelectorAll('.popup');
      allPopUpListenerClass.forEach((buttonItem) => {
        if (buttonItem.attributes.popupAlert) {
          buttonItem.addEventListener("mouseover", (evt) => {
            mypopup.querySelector('b').innerHTML = ''; 
            // mypopup.querySelector('div').style.display = 'block';

            if (evt.target.attributes.popupAlert)
              mypopup.querySelector('b').innerHTML = evt.target.attributes.popupAlert.nodeValue;

            if (evt.target.attributes.popupMsg) {
              mypopup.querySelector('div').style.display = 'block';

              if(evt.target.attributes.popupMsg.nodeValue.length == 19)
                mypopup.querySelector('div').innerHTML = tools.dateStringFullAddTimeZone(evt.target.attributes.popupMsg.nodeValue, curTimeZone);
              else
                  mypopup.querySelector('div').innerHTML = evt.target.attributes.popupMsg.nodeValue;
            }
            else{

              mypopup.querySelector('div').style.display = 'none';
              mypopup.querySelector('div').innerHTML = '';
            }
            

            let iconPos = evt.target.getBoundingClientRect();
            let shift = 30;

            if(evt.target.attributes.popupShift)
              shift = evt.target.attributes.popupShift.nodeValue;

              mypopup.style.left = (iconPos.right - 190 - shift) + "px";


            mypopup.style.top = (window.scrollY + iconPos.top + 0) + "px";
            mypopup.style.display = "block";
          });
          buttonItem.addEventListener("mouseout", ()=> {
            mypopup.style.display = "none";
          });
        }
      });



    } else
      listPointsBody.innerHTML = ' ';
  },


  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
